<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" inline :rules="dataRule" ref="dataForm" label-width="80px">
        <el-form-item label="学员姓名" prop="studentName">
            <el-input disabled v-model="dataForm.studentName"></el-input>
        </el-form-item>
        <el-form-item label="课程名称" prop="courseId">
            <el-dict-select placeholder="课程名称" v-model="dataForm.courseId" type="courseSelects" :props="{value: 'id', label: 'courseName'}"></el-dict-select>
        </el-form-item>
        <el-form-item label="所扣课时" prop="courseId">
            <el-input type="number" min="0" v-model="dataForm.courseNum" :disabled="dataForm.classNumSettlementStatus==='1'"></el-input>
        </el-form-item>
        <el-form-item label="任课老师" prop="teacherId">
            <el-dict-select placeholder="任课老师" v-model="dataForm.teacherId" type="teacherSelects" :props="{label: 'realName', value: 'userId'}"></el-dict-select>
        </el-form-item>
        <el-form-item label="上课日期" prop="sDate" required>
            <el-form-item prop="sDate">
                <el-date-picker style="flex: 3;" v-model="dataForm.sDate" align="right" :picker-options="pickerOptions" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item prop="sTime">
                <el-time-select style="flex: 2;" placeholder="起始时间" v-model="dataForm.sTime" :picker-options="{
              start: '09:00',
              step: '00:30',
              end: '21:30'
            }">
                </el-time-select>
            </el-form-item>
            <el-form-item prop="eTime">
                <el-time-select style="flex: 2;" placeholder="结束时间" v-model="dataForm.eTime" :picker-options="{
              start: '09:00',
              step: '00:30',
              end: '21:30',
              minTime: dataForm.sTime
            }">
                </el-time-select>
            </el-form-item>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            dataForm: {
                courseName: '',
                courseId: '',
                courseNum: '',
                teacherId: '',
                studentName: '',
                classNumSettlementStatus: '',
                sDate: '',
                sTime: '',
                eTime: ''
            },
            dataRule: {
                sDate: {
                    required: true,
                    message: '请选择排课日期',
                    trigger: 'change'
                },
                sTime: {
                    required: true,
                    message: '请选择开始日期',
                    trigger: 'change'
                },
                eTime: {
                    required: true,
                    message: '请选择结束日期',
                    trigger: 'change'
                }
            },
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周后',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            }
        }
    },
    watch: {
        newValue() {
            this.getCourseNum();
        }
    },
    computed: {
        newValue() {
            return this.dataForm.courseId
        }
    },
    methods: {
        init(id) {
            this.dataForm.id = id
            this.visible = true
            this.$nextTick(() => {
                if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`course/studentClass/info/${this.dataForm.id}`),
                        method: 'get'
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.dataForm.courseName = data.studentClass.course_name
                            this.dataForm.courseId = data.studentClass.course_id
                            this.dataForm.courseNum = data.studentClass.course_num
                            this.dataForm.teacherId = data.studentClass.teacher_id
                            this.dataForm.studentName = data.studentClass.student_name
                            this.dataForm.classNumSettlementStatus = data.studentClass.class_num_settlement_status+''
                            this.dataForm.sDate = data.studentClass.end_time.slice(0, 10)
                            this.dataForm.sTime = data.studentClass.start_time.slice(11, 16)
                            this.dataForm.eTime = data.studentClass.end_time.slice(11, 16)
                        }
                    })
                }
            })
        },
        getCourseNum() {
            this.$nextTick(() => {
                this.$http({
                    url: this.$http.adornUrl(`course/course/getCourseNum/${this.dataForm.courseId}`),
                    method: 'get'
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        console.log(data.data)
                        this.dataForm.courseNum = data.data;
                    }
                })
            })
        },
        // 表单提交
        dataFormSubmit() {
            if (this.dataForm.courseNum < 0) {
                this.$message.error("所扣课时不能为负数！")
                return
            }
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: this.$http.adornUrl(`/course/studentClass/update`),
                        method: `put`,
                        data: this.$http.adornData({
                            id: this.dataForm.id,
                            courseId: this.dataForm.courseId,
                            courseNum: this.dataForm.courseNum,
                            teacherId: this.dataForm.teacherId,
                            startTime: this.dataForm.sDate + ' ' + this.dataForm.sTime + ':00',
                            endTime: this.dataForm.sDate + ' ' + this.dataForm.eTime + ':00',
                        })
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: '更新成功',
                                type: 'success'
                            })
                            this.visible = false
                            this.$emit('refreshDataList')
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
